






















































import Header from "@/layout/Header";
import Footer from "@/layout/Footer";

import { General, Home, App } from "@/utils/constants";
import { sanitizedHtml } from "@/utils/dataManipulation";
import { mapGetters, mapActions } from "vuex";
import MediaShareBar from "@/components/MediaShareBar";

export default {
  name: "Reference",
  components: {
    Header,
    Footer,
    MediaShareBar
  },
  data() {
    return {
      General,
      Home,
      App,
      sanitizedHtml,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters({
      getLaw: "getLaw",
      isContrast: "isContrast"
    }),

    currentUrl() {
      return window.location.href;
    }
  },
  async beforeMount() {
    this.isLoading = true;
    await this.getLawList();
    this.isLoading = false;
  },
  methods: {
    ...mapActions({
      getLawList: "getLawList"
    }),

    goRoot() {
      this.$router.replace("/");
    }
  }
};
